module.exports = __webpack_public_path__ + "static/media/linkedIn.23935b26.png";